import TagsLayout from '../components/layouts/TagsLayout.vue';
import TagsIndexPage from '../pages/TagsIndexPage.vue';

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
    {
        // This is the parent route for your package.
        // It uses the layout component.
        path: '/tags',
        name: 'tags.root',
        component: TagsLayout,
        meta: {
            // e.g., requiresAuth: true
            // requiresAuth: true,
            // title: 'tags.nav.title',
            // layout: 'Authenticated',
        },
        // All other package routes are children of this layout
        children: [
            {
                // Child path is empty, so it renders at /tags
                path: '',
                name: 'TagsIndexPage',
                component: TagsIndexPage,
            },
            // --- Example of other child routes ---
            // {
            //   path: 'create', // Renders at /tags/create
            //   name: 'tags.create',
            //   component: () => import('../components/Create.vue'),
            // },
        ]
    }
];
